export const resourcesContent = [
  {
    label: "Acts & Rules",
    table: [
      {
        sl: "0",
        label: `IT Circular 16/2021 - Extension of timelines for filing of various Forms under IT Act, 1961`,
        link: "",
        attachment: `https://Kbiafiling.in/storage/attachment/7ITgB6gBrbQWpnMsl86Ks1qpkLHA3Kbzg8TJKmTg.pdf`,
      },
      {
        sl: "1",
        label: `IT Circular 17 / 2021 - Extension of due dates for filing of Income Tax Return for AY 2021-22`,
        link: "",
        attachment: `https://Kbiafiling.in/storage/attachment/7ITgB6gBrbQWpnMsl86Ks1qpkLHA3Kbzg8TJKmTg.pdf`,
      },
      {
        sl: "2",
        label: `GST - Notification 33/2021 - Extension of Amnesty Scheme & revocation of cancelled GST registration`,
        link: "",
        attachment: `https://Kbiafiling.in/storage/attachment/7ITgB6gBrbQWpnMsl86Ks1qpkLHA3Kbzg8TJKmTg.pdf`,
      },
    ],
  },
  {
    label: "Union Budget 2022",
    table: [
      {
        sl: "0",
        label: `Finance Bill 2022`,
        link: "",
        attachment: `https://Kbiafiling.in/storage/attachment/7ITgB6gBrbQWpnMsl86Ks1qpkLHA3Kbzg8TJKmTg.pdf`,
      },
      {
        sl: "1",
        label: `Memorandum Explaining Finance Bill 2022`,
        link: "",
        attachment: `https://Kbiafiling.in/storage/attachment/7ITgB6gBrbQWpnMsl86Ks1qpkLHA3Kbzg8TJKmTg.pdf`,
      },
      {
        sl: "2",
        label: `Key Features of Budget 2022`,
        link: "",
        attachment: `https://Kbiafiling.in/storage/attachment/7ITgB6gBrbQWpnMsl86Ks1qpkLHA3Kbzg8TJKmTg.pdf`,
      },
      {
        sl: "3",
        label: `Implementation of Budget 2021-2022`,
        link: "",
        attachment: `https://Kbiafiling.in/storage/attachment/7ITgB6gBrbQWpnMsl86Ks1qpkLHA3Kbzg8TJKmTg.pdf`,
      },
    ],
  },
  {
    label: "Corporate's Financial Information",
    table: [
      {
        sl: "0",
        label: `Corporate Announcements`,
        link: "https://www.bseindia.com/corporates/ann.html",
        attachment: ``,
      },
      {
        sl: "1",
        label: `Result Calendar`,
        link: "https://www.bseindia.com/corporates/ann.html",
        attachment: ``,
      },
      {
        sl: "2",
        label: `Corporate Action - Dividend	`,
        link: "https://www.bseindia.com/corporates/ann.html",
        attachment: "",
      },
      {
        sl: "3",
        label: `Market Holidays`,
        link: "https://www.bseindia.com/corporates/ann.html",
        attachment: ``,
      },
    ],
  },
  {
    label: "Latest Tax updates",
    table: [
      {
        sl: "0",
        label: `Latest GST updates`,
        link: "https://www.bseindia.com/corporates/ann.html",
        attachment: ``,
      },
      {
        sl: "1",
        label: `Latest Income Tax updates`,
        link: "https://www.bseindia.com/corporates/ann.html",
        attachment: ``,
      },
    ],
  },
  {
    label: "Tools & Calculators",
    table: [
      {
        sl: "0",
        label: `Income Tax Calculator: New vs Old Tax Regime`,
        link: "",
        attachment: `https://Kbiafiling.in/storage/attachment/7ITgB6gBrbQWpnMsl86Ks1qpkLHA3Kbzg8TJKmTg.pdf`,
      },
      {
        sl: "1",
        label: `EMI Calculator`,
        link: "",
        attachment: `https://Kbiafiling.in/storage/attachment/7ITgB6gBrbQWpnMsl86Ks1qpkLHA3Kbzg8TJKmTg.pdf`,
      },
    ],
  },
];
